import { APIType } from '~/backend/types';
import { useBackendModels, useModelCustomizations } from './useBackend';

/**
 * Eagerly fetches AI model lists and customizations for all
 * workflow types so they are already in the React Query cache
 * when the user opens the AI Assistant dialog.
 *
 * Must be called from a component that mounts early
 * (e.g. BackendWorkflows). The query keys match the ones
 * used by the individual workflow components, so React Query
 * returns cached data instantly when a tab is opened.
 */
export default function useBackendModelPrefetch() {
    // Contour models + customizations
    useBackendModels(APIType.CONTOURING);
    useModelCustomizations(APIType.CONTOURING);

    // Dose models
    useBackendModels(APIType.DOSE);

    // Image translation models + customizations
    useBackendModels(APIType.TRANSLATION);
    useModelCustomizations(APIType.TRANSLATION);

    // Adapt (registration) models
    useBackendModels(APIType.REGISTRATION);
}
